import script from "./AlloyMonitoringModulesSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AlloyMonitoringModulesSection.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__